import React, { useState, useEffect } from "react";
import RezorpaySettingServices from "../services/RezorpaySetting";
import useAsync from "../hooks/useAsync";
import { FaEye, FaEyeSlash, FaEdit, FaCheck, FaTrash } from "react-icons/fa";
import DeleteButton from './Button/DeleteButton';
import Modal from 'react-modal'; // 👈 Path apne folder ke hisaab se check karein
Modal.setAppElement('#root'); 
const emptyAccount = {
  _id: null,
  accountNumber: null,
  accountLabel: "",
  keyId: "",
  keySecret: "",
  webhookSecret: "",
  isActive: false,
  statusChanged: false,
};

function RezorpaySetting() {
  const { data, error, isLoading, refetch } = useAsync(
    RezorpaySettingServices.getRezorpaySettingDetail
  );
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [accountToDelete, setAccountToDelete] = useState(null);
  const [updatingIndex, setUpdatingIndex] = useState(null);
  const [savingIndex, setSavingIndex] = useState(null);
  const [accounts, setAccounts] = useState([]);
  const [errors, setErrors] = useState({});
  const [showPasswords, setShowPasswords] = useState([]);
  const [saving, setSaving] = useState(false);

  /* ---------------- LOAD ---------------- */
  useEffect(() => {
    if (!data) return;
    const list = Array.isArray(data)
      ? data
      : Array.isArray(data?.data)
        ? data.data
        : Array.isArray(data?.accounts)
          ? data.accounts
          : Array.isArray(data?.data?.accounts)
            ? data.data.accounts
            : [];

    const loaded =
      list.length > 0
        ? list.map((acc) => ({
          _id: acc._id,
          accountNumber: acc.accountNumber ?? null,
          accountLabel: acc.accountLabel || "",
          keyId: acc.keyId || "",
          keySecret: acc.keySecret || "",
          webhookSecret: acc.webhookSecret || "",
          isActive: !!acc.isActive,
          statusChanged: false,
        }))
        : [{ ...emptyAccount, accountNumber: 1, isActive: true }];

    setAccounts(loaded);
    setShowPasswords(
      loaded.map(() => ({ keySecret: false, webhookSecret: false }))
    );
      setErrors({});
    setSavingIndex(null);
    setUpdatingIndex(null);
    setSaving(false);
    setIsDeleteModalOpen(false);
    setAccountToDelete(null);
 
  }, [data]);

    const handleDelete = (index) => {
    const account = accounts[index];
    if (accounts.length === 1) {
      alert("At least one account block is required.");
      return;
    }
    
    setAccountToDelete({ index, data: account });
    setIsDeleteModalOpen(true);
  };
    const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setAccountToDelete(null);
  };
  const isBlockEmpty = (acc) =>
    !acc.accountLabel?.trim() &&
    !acc.keyId?.trim() &&
    !acc.keySecret?.trim() &&
    !acc.webhookSecret?.trim();

  const validateSingleBlock = (acc) => {
    const err = {};
    if (isBlockEmpty(acc)) return err;

    // common required
    if (!acc.accountLabel?.trim()) err.accountLabel = "Account Label is required";
    if (!acc.keyId?.trim()) err.keyId = "Key ID is required";

    // NEW account (no _id) -> keySecret is mandatory
    if (!acc._id && !acc.keySecret?.trim())
      err.keySecret = "Key Secret is required for new account";

    return err;
  };

  const handleInputChange = (index, e) => {
    const { name, value } = e.target;
    if (errors[index]?.[name]) {
      setErrors((prev) => ({
        ...prev,
        [index]: { ...prev[index], [name]: null },
      }));
    }
    setAccounts((prev) =>
      prev.map((acc, i) => (i === index ? {
        ...acc, [name]: value,
        ...(name === "keySecret" && { keySecretDirty: true }),
        ...(name === "webhookSecret" && { webhookSecretDirty: true }),
      } : acc))
    );
  };

  const handleStatusChange = async (index) => {
  const targetAccount = accounts[index];
  setAccounts((prev) =>
    prev.map((acc, i) => {
      if (i !== index) {
        return { ...acc, isActive: false, statusChanged: false };
      }
      return {
        ...acc,
        isActive: true,
        statusChanged: true, 
      };
    })
  );
  setUpdatingIndex(index); 
  try {
    await RezorpaySettingServices.activateRezorpaySetting(targetAccount._id);
    alert(`Account ${index + 1} successfully Active`);
    refetch && refetch();
  } catch (err) {
    console.error("Activate API failed:", err);
    alert(err?.response?.data?.message || err?.message || "Failed to activate account");
    refetch && refetch();
  } finally {
    setUpdatingIndex(null);
  }
};
  const togglePasswordVisibility = (index, field) => {
    setShowPasswords((prev) => {
      const copy = [...prev];
      copy[index] = { ...copy[index], [field]: !copy[index][field] };
      return copy;
    });
  };

  /* ---------------- SAVE SINGLE (CREATE) ---------------- */
  const handleSaveSingle = async (index) => {
    const acc = accounts[index];

    // Sirf new (no _id) accounts ke liye
    if (acc._id) {
      alert("Ye account pehle se saved hai. Update icon use karo.");
      return;
    }

    if (isBlockEmpty(acc)) {
      alert("Please fill at least Account Label, Key ID and Key Secret.");
      return;
    }

    // Validation
    const err = validateSingleBlock(acc) || {};
    if (Object.keys(err).length > 0) {
      setErrors((prev) => ({ ...prev, [index]: err }));
      alert("Please complete the highlighted fields.");
      return;
    }

    setSavingIndex(index);

    try {
      const payload = {
        accountNumber: Number(acc.accountNumber),
        accountLabel: acc.accountLabel.trim(),
        keyId: acc.keyId.trim(),
        keySecret: acc.keySecret.trim(),
      };
      if (acc.webhookSecret?.trim()) {
        payload.webhookSecret = acc.webhookSecret.trim();
      }

      // 🔥 CREATE API call
      const res = await RezorpaySettingServices.createRezorpaySetting(payload);

      const savedId =
        res?.data?._id ||
        res?.data?.data?._id ||
        res?.data?.account?._id ||
        res?.data?.data?.account?._id;

      // Agar user ne is block ko active mark kiya tha
      if (acc.isActive && savedId) {
        await RezorpaySettingServices.activateRezorpaySetting(savedId);
      }

      alert(`Account ${index + 1} saved successfully!`);
      refetch && refetch();
         setErrors({});
      setSavingIndex(null);
      setUpdatingIndex(null);
      setSaving(false);
    } catch (err) {
      console.error("Failed to save account", err);
      alert(
        err?.response?.data?.message ||
        err?.message ||
        "Failed to save account"
      );
    } finally {
      setSavingIndex(null);
    }
  };
  const handleAddMore = () => {


    const newErrors = {};
    let hasError = false;

    accounts.forEach((acc, index) => {
      // Validate only blocks the user has actually started filling
      if (isBlockEmpty(acc)) return;

      const err = {};
      if (!acc.accountLabel.trim()) err.accountLabel = "Account Label is required";
      if (!acc.keyId.trim()) err.keyId = "Key ID is required";
      // Only require keySecret for NEW accounts
      // if (!acc._id && !acc.keySecret.trim())
      //   err.keySecret = "Key Secret is required for new account";

      if (Object.keys(err).length > 0) {
        newErrors[index] = err;
        hasError = true;
      }
    });

    // if (hasError) {
    //   setErrors(newErrors);
    //   alert("Please complete the existing account details first.");
    //   return;
    // }

    setAccounts((prev) => [
      ...prev,
      {
        ...emptyAccount,
        _id: null,
        accountNumber: prev.length + 1,
        accountLabel: "",
        keyId: "",
        keySecret: "",
        webhookSecret: "",
        isActive: false,
        statusChanged: false,
      },
    ]);

    setShowPasswords((prev) => [
      ...prev,
      { keySecret: false, webhookSecret: false },
    ]);

    setErrors({});
  };
  const validateForm = () => {
    const newErrors = {};
    let hasAnyFilled = false;

    accounts.forEach((acc, index) => {
      // skip completely untouched blocks
      if (isBlockEmpty(acc) && !acc._id) return;  // new & empty
      if (isBlockEmpty(acc) && acc._id) return;  // existing & untouched

      hasAnyFilled = true;
      const err = validateSingleBlock(acc) || {};
      if (Object.keys(err).length > 0) newErrors[index] = err;
    });

    if (!hasAnyFilled) {
      alert("Please fill at least one account details.");
      return false;
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      alert("Please complete the highlighted fields.");
      return false;
    }
    return true;
  };

 const handleUpdateSingle = async (index) => {
  const acc = accounts[index];

  if (!acc._id) {
    alert("New account ko pehle 'Save Settings' se create karo.");
    return;
  }

  const err = validateSingleBlock(acc) || {};
  if (Object.keys(err).length > 0) {
    setErrors((prev) => ({ ...prev, [index]: err }));
    alert("Please complete the highlighted fields.");
    return;
  }

  setUpdatingIndex(index);

  try {
    const payload = {
      accountLabel: acc.accountLabel.trim(),
      keyId: acc.keyId.trim(),
    };
    if (acc.keySecret?.trim()) payload.keySecret = acc.keySecret.trim();
    if (acc.webhookSecret?.trim()) payload.webhookSecret = acc.webhookSecret.trim();

    await RezorpaySettingServices.updateRezorpaySettingDetail(acc._id, payload);


    alert(`Account ${index + 1} updated successfully!`);
    refetch && refetch();
  } catch (err) {
    console.error("Failed to update account", err);
    alert(err?.response?.data?.message || err?.message || "Failed to update account");
  } finally {
    setUpdatingIndex(null);
  }
};





  const handleSaveSettings = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setSaving(true);
    try {
      for (const acc of accounts) {
        if (!acc._id) {
          if (isBlockEmpty(acc)) continue;
          if (
            !acc.accountLabel?.trim() ||
            !acc.keyId?.trim() ||
            !acc.keySecret?.trim()
          ) {
            throw new Error(
              "Account Label, Key ID and Key Secret are required for new accounts."
            );
          }
          const payload = {
            accountNumber: Number(acc.accountNumber),
            accountLabel: acc.accountLabel.trim(),
            keyId: acc.keyId.trim(),
            keySecret: acc.keySecret.trim(),
          };
          if (acc.webhookSecret?.trim()) {
            payload.webhookSecret = acc.webhookSecret.trim();
          }
          const res = await RezorpaySettingServices.createRezorpaySetting(payload);
          const savedId =
            res?.data?._id ||
            res?.data?.data?._id ||
            res?.data?.account?._id ||
            res?.data?.data?.account?._id;
          if (acc.isActive && savedId) {
            await RezorpaySettingServices.activateRezorpaySetting(savedId);
          }
          continue;
        }
        if (isBlockEmpty(acc)) continue;
        const payload = {
          accountLabel: acc.accountLabel.trim(),
          keyId: acc.keyId.trim(),
        };
        if (acc.keySecret?.trim()) payload.keySecret = acc.keySecret.trim();
        if (acc.webhookSecret?.trim()) payload.webhookSecret = acc.webhookSecret.trim();
        await RezorpaySettingServices.updateRezorpaySettingDetail(acc._id, payload);
        if (acc.statusChanged && acc.isActive) {
          await RezorpaySettingServices.activateRezorpaySetting(acc._id);
        }
      }

      alert("Settings saved successfully!");
      refetch && refetch();
         setErrors({});
      setSavingIndex(null);
      setUpdatingIndex(null);
      setSaving(false);
    } catch (err) {
      console.error("Failed to save settings", err);
      alert(
        err?.response?.data?.message ||
        err?.message ||
        "Failed to save settings"
      );
    } finally {
      setSaving(false);
    }
  };


  if (isLoading) return <div className="loader design_loading">Loading...</div>;
  if (error) return <div>Error loading razorpay settings</div>;

  return (
    <div className="right_col" role="main">
      <div className="d-md-flex align-items-center justify-content-between my-4 page-header-breadcrumb">
        <div className="my-auto">
          <h5 className="page-title fs-21 mb-1">Razorpay Account Settings</h5>
          <p className="text-muted mb-0" style={{ fontSize: "13px" }}>
            You can configure up to 2 Razorpay accounts. Only one account will
            remain active for transactions.
          </p>
        </div>
        <button
          type="button"
          className="submit-green-btn add_more_btn"
          onClick={handleAddMore}

        >
          ADD MORE
        </button>
      </div>

      <form onSubmit={handleSaveSettings} noValidate>
        {accounts.map((acc, index) => (
          <div className="container-box mb-4" key={acc._id || `new-${index}`}>
            <div className="container-box-inner">
              <div className="page-details appchangedetails">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <div className="d-flex align-items-center gap-3">
                    <h6 className="mb-0 fw-bold">
                      Razorpay Account {index + 1}
                    </h6>
                    {acc.isActive && (
                      <span className="badge bg-success bg-opacity-10 text-light border border-success px-3 py-1 rounded-pill">
                        Currently Active
                      </span>
                    )}
                    {!acc._id && (
                      <span className="badge bg-info bg-opacity-10 text-light border border-info px-3 py-1 rounded-pill">
                        New
                      </span>
                    )}
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <div className="form-check d-flex align-items-center gap-2">
                      <input
                        className="form-check-input m-0"
                        type="radio"
                        name="activeAccount"
                        id={`activeAccount${index}`}
                        checked={acc.isActive}
                        onChange={() => handleStatusChange(index)}
                      // style={{
                      //   cursor: "pointer",
                      //   width: "18px",
                      //   height: "18px",
                      // }}
                      />
                      <label
                        className="form-check-label m-0"
                        htmlFor={`activeAccount${index}`}
                      >
                        {acc.isActive ? "Active" : "Set Active"}
                      </label>
                    </div>
                    {acc._id && (
                      <button
                        type="button"
                        className="submit-green-btn add_more_btn"
                        onClick={() => handleUpdateSingle(index)}
                        disabled={updatingIndex === index || saving}
                        title="Update this account"
                      >
                        {/* <FaEdit /> */}
                        {updatingIndex === index ? "Updating..." : "Update"}
                      </button>
                    )}


                    {!acc._id && (
                      <button
                        type="button"
                        className="submit-green-btn"
                        onClick={() => handleSaveSingle(index)}
                        disabled={savingIndex === index || saving}
                      >
                        {savingIndex === index ? "Saving..." : "Save"}
                      </button>
                    )}
                    {accounts.length > 1 && (
                      <button
                        type="button"
                        className="round-add-btn"
                       onClick={() => handleDelete(index)} 
                      >
                        <FaTrash />
                      </button>
                    )}
                  </div>
                </div>

                <div className="row">
                  {/* Account Label */}
                  <div className="col-lg-12 mb-3">
                    <div className="input-field1">
                      <label>
                        Account Label <span className="text-danger">*</span>
                      </label>
                      <div className="input-link-outer inputpadingnone">
                        <input
                          type="text"
                          name="accountLabel"
                          className={`form-control ${errors[index]?.accountLabel ? "is-invalid" : ""
                            }`}
                          value={acc.accountLabel}
                          onChange={(e) => handleInputChange(index, e)}
                          placeholder="e.g. Primary Account"
                        />
                        {errors[index]?.accountLabel && (
                          <small className="text-danger mt-1 d-block">
                            {errors[index].accountLabel}
                          </small>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Key ID */}
                  <div className="col-lg-12 mb-3">
                    <div className="input-field1">
                      <label>
                        Key ID <span className="text-danger">*</span>
                      </label>
                      <div className="input-link-outer inputpadingnone">
                        <input
                          type="text"
                          name="keyId"
                          className={`form-control ${errors[index]?.keyId ? "is-invalid" : ""
                            }`}
                          value={acc.keyId}
                          onChange={(e) => handleInputChange(index, e)}
                          placeholder=""
                        />
                        {errors[index]?.keyId && (
                          <small className="text-danger mt-1 d-block">
                            {errors[index].keyId}
                          </small>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Key Secret */}
                  <div className="col-lg-12 mb-3">
                    <div className="input-field1">
                      <label>
                        Key Secret <span className="text-danger">*</span>
                        {acc._id && (
                          <small className="text-muted ms-2">
                            (leave blank to keep existing)
                          </small>
                        )}
                      </label>
                      <div className="input-link-outer inputpadingnone position-relative">
                        <input
                          type={
                            showPasswords[index]?.keySecret
                              ? "text"
                              : "password"
                          }
                          name="keySecret"
                          className={`form-control ${errors[index]?.keySecret ? "is-invalid" : ""
                            }`}
                          value={acc.keySecret}
                          onChange={(e) => handleInputChange(index, e)}
                          placeholder={
                            acc._id ? "••••••••" : "••••••••••••"
                          }

                        />
                        <span
                          onClick={() =>
                            togglePasswordVisibility(index, "keySecret")
                          }
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            color: "#666",
                          }}
                        >
                          {showPasswords[index]?.keySecret ? (
                            <FaEyeSlash />
                          ) : (
                            <FaEye />
                          )}
                        </span>
                        {errors[index]?.keySecret && (
                          <small className="text-danger mt-1 d-block">
                            {errors[index].keySecret}
                          </small>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Webhook Secret */}
                  <div className="col-lg-12 mb-3">
                    <div className="input-field1">
                      <label>
                        Webhook Secret{" "}
                        <small className="text-muted">(optional)</small>
                      </label>
                      <div className="input-link-outer inputpadingnone position-relative">
                        <input
                          type={
                            showPasswords[index]?.webhookSecret
                              ? "text"
                              : "password"
                          }
                          name="webhookSecret"
                          className="form-control"
                          value={acc.webhookSecret}
                          onChange={(e) => handleInputChange(index, e)}
                          placeholder="optional"
                          style={{ paddingRight: "40px" }}
                        />
                        <span
                          onClick={() =>
                            togglePasswordVisibility(index, "webhookSecret")
                          }
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            color: "#666",
                          }}
                        >
                          {showPasswords[index]?.webhookSecret ? (
                            <FaEyeSlash />
                          ) : (
                            <FaEye />
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}

        {/* <div className="mt-3 mb-5">
          <p className="text-muted mb-3">
            Only one account can be active at a time.
          </p>
          <div className="d-flex gap-2">
            <button
              type="submit"
              className="submit-green-btn"
              disabled={saving}
            >
              {saving ? "SAVING..." : "SAVE SETTINGS"}
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => refetch && refetch()}
              disabled={saving}
            >
              CANCEL
            </button>
          </div>
        </div> */}
      </form>


       <Modal
        isOpen={isDeleteModalOpen}
        onRequestClose={closeDeleteModal}
        contentLabel="Delete Confirmation"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <DeleteButton 
          data={accountToDelete?.data} 
          page="rezorpay" 
          closeModal={closeDeleteModal} 
          onSuccess={() => {
            setAccounts((prev) => prev.filter((_, i) => i !== accountToDelete.index));
            setShowPasswords((prev) => prev.filter((_, i) => i !== accountToDelete.index));
            setErrors({});
            setIsDeleteModalOpen(false);
            setAccountToDelete(null);
               refetch && refetch();
            setSavingIndex(null);
            setUpdatingIndex(null);
            setSaving(false);
          }} 
        />
      </Modal>

    </div>
  );
}

export default RezorpaySetting;